<template>
    <div>
        <el-dialog :title="$tx('gwgl.components.transferNotice', '转通知公告')" :visible.sync="dzggShow" width="1000px" @close="toclose">
            <div>
                <el-form :model="dzggObj">
                    <div style="width: 100%" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                <tbody>
                                    <tr>
                                        <td ref="tdlbl_制度标题" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'flSubject'" class="field">文件标题</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="flSubject"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '1',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: $tx('gwgl.components.zdTitleEmptyMessage', '请输入制度主题'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: $tx('gwgl.components.zdTitle', '制度标题'),
                                                    propName: 'flSubject',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'dzggObj.flSubject',
                                                    option: []
                                                }"
                                                :vo="dzggObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_公告类型 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'type'" class="field">公告类型</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="type"
                                                :field="{
                                                    cssClass: null,
                                                    cssStyle: null,
                                                    defaultValue: null,
                                                    elementCanEdit: '1',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: $tx('gwgl.components.notice', '公告') + '：' + $tx('gwgl.components.notice', '公告') + '\n' + $tx('gwgl.components.inform', '通知') + '：' + $tx('gwgl.components.inform', '通知') + '\n' + $tx('gwgl.components.praise', '表扬') + '：' + $tx('gwgl.components.praise', '表扬') + '\n' + $tx('gwgl.components.criticize', '批评') + '：' + $tx('gwgl.components.criticize', '批评') + '\n' + $tx('gwgl.components.other', '其他') + '：' + $tx('gwgl.components.other', '其他'),
                                                    elementReadonly: 0,
                                                    elementType: 'radio',
                                                    emptyMessage: $tx('gwgl.components.selectType', '请选择公告类型'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 24,
                                                    isRequired: 1,
                                                    onBlurEvent: null,
                                                    onChangeEvent: null,
                                                    onClickEvent: '@change=\'handleTypeChange\'',
                                                    onDblClickEvent: null,
                                                    onFocusEvent: null,
                                                    onKeyDownEvent: null,
                                                    onKeyPressEvent: null,
                                                    onKeyUpEvent: null,
                                                    onMouseDownEvent: null,
                                                    onMouseOverEvent: null,
                                                    onMouseUpEvent: null,
                                                    passenger: {},
                                                    propComment: '公告类型',
                                                    propName: 'type',
                                                    propType: 'String',
                                                    textFormatter: 'radio',
                                                    valueMaxLength: 20,
                                                    valueMinLength: null,
                                                    model: 'dzggObj.type',
                                                    option: [
                                                        { value: $tx('gwgl.components.notice', '公告'), name: $tx('gwgl.components.notice', '公告') },
                                                        { value: $tx('gwgl.components.inform', '通知'), name: $tx('gwgl.components.inform', '通知') },
                                                        { value: $tx('gwgl.components.praise', '表扬'), name: $tx('gwgl.components.praise', '表扬') },
                                                        { value: $tx('gwgl.components.criticize', '批评'), name: $tx('gwgl.components.criticize', '批评') },
                                                        { value: $tx('gwgl.components.other', '其他'), name: $tx('gwgl.components.other', '其他') }
                                                    ],
                                                    optionGenerateType: 0,
                                                    clearable: true,
                                                    filterable: false,
                                                    allowCreate: false
                                                }"
                                                :vo="dzggObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_是否置顶" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'isTop'" class="field">{{ $tx('gwgl.components.isTop') }}</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="isTop"
                                                :field="{
                                                    defaultValue: '0',
                                                    elementCanEdit: '1',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: '0：' + $tx('common.no', '否') + ' \n1：' + $tx('common.no', '否'),
                                                    elementReadonly: 0,
                                                    elementType: 'radio',
                                                    emptyMessage: $tx('gwgl.common.please', '请输入') + '0：' + $tx('common.no', '否') + '  1：' + $tx('common.yes', '是'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 0,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: $tx('gwgl.common.isTop'),
                                                    propName: 'isTop',
                                                    propType: 'Short',
                                                    textFormatter: 'integer',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'dzggObj.isTop',
                                                    option: [
                                                        { value: '0', name: $tx('common.no', '否') },
                                                        { value: '1', name: $tx('common.yes', '是') }
                                                    ],
                                                    optionGenerateType: 0,
                                                    clearable: true,
                                                    filterable: false,
                                                    allowCreate: false
                                                }"
                                                :vo="dzggObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_公告时间" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'ggTime'" class="field">公告时间</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <datetime-range :vo="dzggObj" :type="'datetime'" :v-model-start="'startTime'" :v-model-end="'endTime'" :can-edit="1" :placeholder-start="$tx('fields.startTime', '开始时间')" :placeholder-end="$tx('fields.endTime', '结束时间')" :required="true" :format="'yyyy-MM-dd HH:mm'" />
                                        </td>
                                    </tr>
                                    <tr v-if="false">
                                        <td ref="tdlbl_公告时间" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="''" class="field">公告时间</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5"></td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_发布范围 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'publishScope'" class="field">发布范围</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="publishScope"
                                                :field="{
                                                    textFormatter: 'radio',
                                                    elementType: 'radio',
                                                    propName: 'publishScope',
                                                    propType: 'Short',
                                                    model: 'dzggObj.publishScope',
                                                    emptyMessage: $tx('gwgl.components.publishScopeRange', '请选择发布范围'),
                                                    isRequired: 0,
                                                    elementCanEdit: '1',
                                                    defaultValue: '0',
                                                    elementReadonly: 0,
                                                    option: [
                                                        { value: '0', name: $tx('gwgl.components.allPerson', '全部人员') },
                                                        { value: '1', name: $tx('gwgl.components.fields.readersName', '指定人员') }
                                                    ],
                                                    elementFormatter: '0：' + $tx('gwgl.components.allPerson', '全部人员') + '\n1：' + $tx('gwgl.components.fields.readersName', '指定人员'),
                                                    propComment: '发布范围',
                                                    optionGenerateType: 0,
                                                    clearable: true,
                                                    filterable: false,
                                                    allowCreate: false
                                                }"
                                                :vo="dzggObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr v-if="dzggObj.publishScope == 1">
                                        <td ref="tdlbl_查阅人" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'readersName'" class="field">指定人员</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="readersName"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '1',
                                                    elementCssHeight: 70,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'textarea',
                                                    emptyMessage: $tx('gwgl.components.readeremptyMessage', '请输入查阅人'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 24,
                                                    isRequired: 0,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '查阅人',
                                                    propName: 'readersName',
                                                    propType: 'String',
                                                    textFormatter: 'textarea',
                                                    valueMaxLength: 2147483647,
                                                    valueMinLength: null,
                                                    model: 'dzggObj.readersName',
                                                    option: [],
                                                    dialog: 1,
                                                    dialogType: 'staff',
                                                    dialogMultiple: true,
                                                    dialogOrgLevel: '',
                                                    autosize: false,
                                                    dialogSubOrgName: '',
                                                    valueIdsField: 'readersAccountId'
                                                }"
                                                :vo="dzggObj"
                                                :can-edit="canEdit"
                                                :autosize="false"
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td ref="tdlbl_转规章制度文件" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'publishFiles'" class="field">发布文件</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <span v-if="bodyfile" style="color: #409eff" @click="toview">{{ bodyfile.fileName }}</span>
                                            <span v-else v-text-lbl="'autoReadFile'">自动读取正文</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_附件" v-field-lbl="'attachs'" class="el-table__cell tdlbl tdw17">附件</td>
                                        <td class="el-table__cell tdcont tdcont" colspan="5">
                                            <div v-if="$parent && $parent.attachments">
                                                <el-table ref="multipleTable" class="eltable" :show-header="false" :data="attachments" @selection-change="headSelectRow">
                                                    <el-table-column type="selection" style="border: none" width="35px" align="right" :show-overflow-tooltip="true"></el-table-column>
                                                    <el-table-column prop="fileName" style="border: none" :label="$tx('gwgl.components.fileName', '文件名')" width="" align="left" :show-overflow-tooltip="true"></el-table-column>
                                                    <el-table-column prop="fileSize" style="border: none" :label="$tx('gwgl.components.fileSize', '文件大小')" width="100px" align="right" :show-overflow-tooltip="true"></el-table-column>
                                                </el-table>
                                            </div>
                                            <div v-else>
                                                <span v-text-lbl="'common.noData'">暂无数据</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-field-lbl="'cancel'" @click="toclose">取 消</el-button>
                <el-button v-field-lbl="'sure'" type="primary" @click="zggzdFn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        bodyfile: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'gwgl',
            moduleCode: 'components',
            attachments: [],
            dzggShow: false,
            selectFileIds: '',
            dzggObj: {},
            nowTime: this.$moment(new Date()).format('YYYY-MM-DD HH:mm')
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('btnTotzggClick', this.btnTotzggClick)
    },
    beforeDestroy() {
        this.$bus.off('btnTotzggClick', this.btnTotzggClick)
    },
    mounted() {},
    methods: {
        toclose() {
            this.dzggShow = false
            this.$parent.FromDialogShow = false
            this.$options.components['FromDialog'] = ''
            console.log(this.$options.components)
        },
        // 转督办事项
        zggzdFn() {
            const _this = this
            if (!_this.dzggObj.flSubject) {
                this.$alert(this.$tx('gwgl.components.fixTitle', '请填写文件标题！'), this.$tx('common.operationTip', '操作提示'), {
                    type: 'warning'
                })
                return
            }

            if (!_this.dzggObj.type) {
                this.$alert(this.$tx('gwgl.components.selectType', '请选择公告类型'), this.$tx('common.operationTip', '操作提示'), {
                    type: 'warning'
                })
                return
            }

            // if (!_this.dzggObj.isTop) {
            //     this.$alert('请选择是否置顶', '提示', {
            //         type: 'warning'
            //     })
            //     return
            // }

            if (this.dzggObj.passenger.attachments && this.dzggObj.passenger.attachments.length > 0) {
                this.dzggObj.passenger.attachments = this.dzggObj.passenger.attachments.filter((attachment) => {
                    return this.dzggObj.passenger.selectFileIds.includes(attachment.id)
                })
            }
            // if (this.bodyfile) {
            //     this.dzggObj.passenger.attachments = [this.bodyfile]
            // }
            this.$http({
                method: 'post',
                url: '/ecoa/dzgg/activateWfInstance',
                data: this.dzggObj
            }).then((res) => {
                if (res.code === 'success') {
                    console.log('res', res)
                    this.$message.success(res.message)
                    this.dzggShow = false
                } else {
                    this.$message.error(res.message)
                    this.dzggShow = false
                }
            })
        },
        onSelectStaffCompleted: function (selectedNodes, attr) {
            let selectedNames = ''
            let selectedAccountIds = ''
            selectedNodes.forEach(function (node) {
                if (selectedNames != '') selectedNames += '、'
                if (selectedAccountIds != '') selectedAccountIds += ','
                selectedNames += node.name
                selectedAccountIds += node.personId
            })
            //this.$set(this.dzggObj, 'publishScope', 0)
            // this.$nextTick(function(){
            this.$set(this.dzggObj, 'readersName', selectedNames)
            this.$set(this.dzggObj, 'readersAccountId', selectedAccountIds)
            console.log('123', this.dzggObj.readersName)
            console.log('123', this.dzggObj.readersAccountId)
            //	this.$set(this.dzggObj, 'publishScope', 1)
            //  })
        },
        toview() {
            console.log(this, 'thisssss')
            window.open('/apigw/' + this.$parent.wfEngineUrl + '/downloadById?attachIds=' + this.bodyfile.id + '&inline=true')
        },
        // 选择附件
        headSelectRow(selection) {
            let selectFiles = ''
            selection.forEach((file) => {
                if (file.id) {
                    if (selectFiles !== '') selectFiles += ','
                    selectFiles += file.id
                }
            })

            this.selectFileIds = selectFiles
            this.dzggObj.passenger.selectFileIds = this.selectFileIds
            // console.log(this.dzggObj, 'this.selectFileIds')
        },

        // 转规章制度
        btnTotzggClick() {
            this.dzggObj = {
                readersName: '',
                publishScope: 0,
                endTime: '',
                startTime: '',
                isTop: 0,
                type: '公告',
                passenger: { attachments: [] },
                flSubject: this.vo.flSubject
            }
            if (this.$parent.attachments) {
                var list = this.$parent.attachments

                list = list.filter(item => (item.fileType === 'BODY' && item.id === this.bodyfile.id) || item.fileType !== 'BODY')
                list = JSON.parse(JSON.stringify(list))
                list.forEach((v) => {
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.$refs.multipleTable.toggleRowSelection(v)
                        })
                    })
                    if (v.fileName.indexOf('.doc') > -1 && v.fileType === 'BODY') {
                        v.fileName = '文件正文.doc'
                    }
                })
                this.dzggObj.passenger.attachments = list
                this.attachments = this.dzggObj.passenger.attachments
            }

            // console.log(this.bodyfile, 'bodyfilebodyfile')
            this.dzggShow = true
        }
    }
}
</script>

    <style scoped lang="scss">
// /deep/ .el-table .cell.el-tooltip{
//     min-width: auto;
// }
/deep/.el-checkbox:last-of-type {
    margin-right: 25px !important;
}
/deep/.el-table td {
    border-bottom: none;
}
.eltable {
    border: 1px solid #ebeef5;
    border-bottom: none;
    /deep/.el-table__body {
        width: 100% !important;
    }
}
/deep/.el-table--enable-row-transition .el-table__body td.el-table__cell {
    border: none;
    border-bottom: none !important;
}
</style>
